import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Table, Pagination, Button, Space, Dropdown, Menu, message , Modal, Input, Switch, Radio, InputNumber, Select } from 'antd';
import { Card } from 'react-bootstrap';
import { DownloadOutlined, EditOutlined, EllipsisOutlined ,RollbackOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';

// Import Modal Components
import FundTransfer from "../createUserDistributer/fundTrnsfer/FundTrnasfer";
import SchemeManager from "../createUserDistributer/schemeManager/SchemeManager";
import IdStocks from "../createUserDistributer/IdsStoks/IdStoks";
import MemberPermission from "../createUserDistributer/memberPermission/MemberPermission";
import LockAmount from "../createUserDistributer/lockAmount/LockAmount";

import './distributor.css';
import '../distributer.css';
import { reverseaepsPayment, reversePayment, reverseCashbackPayment, updateUser, getUserId, getEligibleParents, changeUserParent } from '../../../api/login/Login';

const DistributorList = ({
  loading,
  params,
  state,
  excelData,
  handleChange,
  onChangeVal,
  updateActiveStatus,
  getReailerDistIdAgainst
  ,submitForm,initialValues ,page
}) => {
  // Modal states
  const [cashbackModalVisible, setCashbackModalVisible] = useState(false);
  const [selectedCashbackUser, setSelectedCashbackUser] = useState(null);
  const [cashbackEnabled, setCashbackEnabled] = useState(false);
  const [cashbackChargeType, setCashbackChargeType] = useState('Percent');
  const [cashbackChargeValue, setCashbackChargeValue] = useState(0);
  const [cashbackMinAmount, setCashbackMinAmount] = useState(100);
  const [cashbackMaxAmount, setCashbackMaxAmount] = useState(50000);
  const [cashbackMinFlat, setCashbackMinFlat] = useState(10);
  const [cashbackMaxPercent, setCashbackMaxPercent] = useState(2);
  const [cashbackGstRate, setCashbackGstRate] = useState(18);
  const [cashbackGstType, setCashbackGstType] = useState("Include");
  const [cashbackUpiMinPerTxn, setCashbackUpiMinPerTxn] = useState(100);
  const [cashbackUpiMaxPerTxn, setCashbackUpiMaxPerTxn] = useState(50000);
  const [cashbackUpiDailyLimit, setCashbackUpiDailyLimit] = useState(100000);
  const [cashbackBankMinPerTxn, setCashbackBankMinPerTxn] = useState(100);
  const [cashbackBankMaxPerTxn, setCashbackBankMaxPerTxn] = useState(50000);
  const [cashbackBankDailyLimit, setCashbackBankDailyLimit] = useState(200000);
  const [cashbackModalLoading, setCashbackModalLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [error, setError] = useState(null);
  const [userMainWallet , setUserMainWallet] = useState(0);
  const [userAepsWallet, setUserAepsWallet] = useState(0);
  const [userCashbackReverseWallet, setUserCashbackReverseWallet] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true)

   const [isParentViewVisible, setIsParentViewVisible] = useState(false);
    const [parentRecord , setParentRecord] = useState([]);
    const [downlineRecord, setDownlineRecord] = useState([]);
    const [selectedMemberForParent, setSelectedMemberForParent] = useState(null);
    const [showChangeParentPanel, setShowChangeParentPanel] = useState(false);
    const [changeParentRole, setChangeParentRole] = useState('Distributor');
    const [eligibleParentsList, setEligibleParentsList] = useState([]);
    const [eligibleParentsLoading, setEligibleParentsLoading] = useState(false);
    const [selectedNewParentId, setSelectedNewParentId] = useState(null);
    const [changeParentSubmitting, setChangeParentSubmitting] = useState(false);

    const fetchEligibleParents = async (role = changeParentRole, search = '') => {
      try {
        setEligibleParentsLoading(true);
        const res = await getEligibleParents(role, search);
        const parents = res?.data?.parents || res?.parents || [];
        const filtered = parents.filter(p => String(p._id) !== String(selectedMemberForParent?._id));
        setEligibleParentsList(filtered);
      } catch (err) {
        console.error("Error fetching eligible parents:", err);
        message.error("Failed to load eligible parents");
      } finally {
        setEligibleParentsLoading(false);
      }
    };

    const handleToggleChangeParent = () => {
      const nextState = !showChangeParentPanel;
      setShowChangeParentPanel(nextState);
      if (nextState) {
        setSelectedNewParentId(null);
        let defaultRole = 'ASM';
        const memberRole = (
          selectedMemberForParent?.user_type_id?.user_type ||
          selectedMemberForParent?.member_type ||
          selectedMemberForParent?.user_type ||
          ''
        ).toLowerCase();

        if (memberRole.includes('super distributor') || memberRole.includes('super_distributor')) {
          defaultRole = 'ASM';
        } else if (memberRole.includes('distributor')) {
          defaultRole = 'Super Distributor';
        } else if (memberRole.includes('retailer')) {
          defaultRole = 'Distributor';
        } else if (memberRole.includes('asm')) {
          defaultRole = 'TSM';
        } else if (memberRole.includes('tsm')) {
          defaultRole = 'ZSM';
        } else {
          defaultRole = 'ASM';
        }

        setChangeParentRole(defaultRole);
        fetchEligibleParents(defaultRole);
      }
    };

    const handleChangeParentRole = (role) => {
      setChangeParentRole(role);
      setSelectedNewParentId(null);
      fetchEligibleParents(role);
    };

    const handleSubmitChangeParent = async () => {
      if (!selectedMemberForParent?._id) {
        message.error("No member selected");
        return;
      }
      if (!selectedNewParentId) {
        message.error("Please select a new parent/sponsor");
        return;
      }
      try {
        setChangeParentSubmitting(true);
        const res = await changeUserParent(selectedMemberForParent._id, {
          new_parent_id: selectedNewParentId
        });

        const isSuccess = Boolean(
          res?.status_Code === "200" ||
          res?.statusCode === 200 ||
          res?.status === 200 ||
          res?.data?.uplineChain ||
          res?.uplineChain
        );

        if (isSuccess) {
          message.success(res?.data?.message || res?.message || "Parent updated successfully!");
          const freshChain = res?.data?.uplineChain || res?.uplineChain;
          if (freshChain) {
            setParentRecord(freshChain);
          }
          setShowChangeParentPanel(false);
          setSelectedNewParentId(null);
          if (typeof getReailerDistIdAgainst === 'function') {
            getReailerDistIdAgainst(page ? page : 0);
          }
        } else {
          message.error(res?.data?.message || res?.message || "Failed to update parent");
        }
      } catch (err) {
        console.error("Error updating parent:", err);
        message.error(err?.response?.data?.message || err?.data?.message || err?.message || "Failed to update parent");
      } finally {
        setChangeParentSubmitting(false);
      }
    };

    const columnsParent = [
  
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Refer Id',
        dataIndex: 'refer_id',
        key: 'refer_id',
      },
      {
        title: 'Mobile',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: 'Main Wallet',
        dataIndex: 'main_wallet',
        key: 'main_wallet',
      },
      {
        title: 'User Type',
        dataIndex: 'user_type',
        key: 'user_type',
      }
    ]

    const showParentView = (uplineChain, downlineSponsors, record = null)=>{
      let upline = Array.isArray(uplineChain) ? [...uplineChain] : [];
      if (upline?.length > 0) {
        upline.sort((a, b) => (a.depth || 0) - (b.depth || 0));
      }
      let downline = Array.isArray(downlineSponsors) ? [...downlineSponsors] : [];
      setIsParentViewVisible(true);
      setParentRecord(upline);
      setDownlineRecord(downline);
      setSelectedMemberForParent(record);
      setShowChangeParentPanel(false);
      setSelectedNewParentId(null);
    }
  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true)
  const [show5, setShow5] = useState(false);
  const [reverseModalLoading, setReverseModalLoading] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [reversePaymentData, setReversePaymentData] = useState({
    userId: '',
    amount: '',
    remark: '',
    tpin: ''
  });
  const [aepsreverseModalLoading, setaepsReverseModalLoading] = useState(false);
  const [showaepsReverseModal, setaepsShowReverseModal] = useState(false);
  const [aepsreversePaymentData, setaepsReversePaymentData] = useState({
    userId: '',
    amount: '',
    remark: '',
    tpin: ''
  });

  const [cashbackReverseModalLoading, setCashbackReverseModalLoading] = useState(false);
  const [showCashbackReverseModal, setShowCashbackReverseModal] = useState(false);
  const [cashbackReversePaymentData, setCashbackReversePaymentData] = useState({
    userId: '',
    amount: '',
    remark: '',
    tpin: ''
  });


  const handleClose5 = () => setShow5(false);
  const [getItem, setGetItem] = useState()
  const handleShow5 = (item) => {
      setGetItem({ ...item, paramId: params?.id })
      setTimeout(() => {
          setShow5(true)
      }, 1000);
  }

  console.log("page",page)

  // Modal handlers
  // const handleLockAmount = (item) => {
  //   setSelectedItem({ ...item, paramId: params?.id });
  //   setShowLockAmount(true);
  // };

  const handleReverseModalOpen = (record) => {
    console.log(record , "Record")
    setUserMainWallet(record?.main_wallet || 0);

    setReversePaymentData(prev => ({
      ...prev,
      userId: record._id,
      amount: '',
      remark: '',
      tpin: ''
    }));
    setShowReverseModal(true);
  };

  const handleaepsReverseModalOpen = (record) => {
    console.log(record , "Record")
    setUserAepsWallet(record?.aeps_wallet || 0);
    setaepsReversePaymentData(prev => ({
      ...prev,
      userId: record._id,
      amount: '',
      remark: '',
      tpin: ''
    }));
    setaepsShowReverseModal(true);
  };

  const handleCashbackReverseModalOpen = (record) => {
    console.log(record , "Record")
    setUserCashbackReverseWallet(record?.cashback_wallet || 0);
    setCashbackReversePaymentData(prev => ({
      ...prev,
      userId: record._id,
      amount: '',
      remark: '',
      tpin: ''
    }));
    setShowCashbackReverseModal(true);
  };

  const handleReverseModalClose = () => {
    setUserMainWallet(0)
    setShowReverseModal(false);
    setReverseModalLoading(false);
    setReversePaymentData({
      userId: '',
      amount: '',
      remark: '',
      tpin: ''
    });
  };

  const handleaepsReverseModalClose = () => {
    setUserAepsWallet(0);
    setaepsShowReverseModal(false);
    setaepsReverseModalLoading(false);
    setaepsReversePaymentData({
      userId: '',
      amount: '',
      remark: '',
      tpin: ''
    });
  };

  const handleCashbackReverseModalClose = () => {
    setUserCashbackReverseWallet(0);
    setShowCashbackReverseModal(false);
    setCashbackReverseModalLoading(false);
    setCashbackReversePaymentData({
      userId: '',
      amount: '',
      remark: '',
      tpin: ''
    });
  };

  const handleaepsReversePaymentSubmit = async()=>{
    try {
      setaepsReverseModalLoading(true); // Show loader

      const response = await reverseaepsPayment(aepsreversePaymentData);
  
      if (response?.statusCode === "200" || response?.status === 200 || response?.data?.status_Code === "200" || response?.data?.statusCode === 200) {
        message.success(response?.data?.message || response?.message || 'Payment reversed successfully');
        handleaepsReverseModalClose(); // Close the modal
        if (getReailerDistIdAgainst ) {
          await getReailerDistIdAgainst(page ? page : 0);
        }

      } else {
        message.error(response?.data?.message || response?.message || 'Failed to reverse payment');
      }
    } catch (err) {
      message.error(err?.data?.message || err?.message || 'Failed to reverse payment');
    } finally {
      setaepsReverseModalLoading(false); // Hide loader
    }
  }

  const handleCashbackReversePaymentSubmit = async () => {
    try {
      setCashbackReverseModalLoading(true);
      const response = await reverseCashbackPayment(cashbackReversePaymentData);

      if (response?.data?.statusCode === 200 || response?.data?.status_Code === "200" || response?.statusCode === "200" || response?.status === 200) {
        message.success(response?.data?.message || response?.message || 'Cashback payment reversed successfully');
        handleCashbackReverseModalClose();
        if (getReailerDistIdAgainst) {
          await getReailerDistIdAgainst(page ? page : 0);
        }
      } else {
        message.error(response?.data?.message || response?.message || 'Failed to reverse cashback payment');
      }
    } catch (err) {
      message.error(err?.response?.data?.message || err?.message || 'Failed to reverse cashback payment');
    } finally {
      setCashbackReverseModalLoading(false);
    }
  };

  const handleReversePaymentSubmit= async () => {
    try {
      setReverseModalLoading(true); // Show loader
      const response = await reversePayment(reversePaymentData);
  
      if (response.statusCode === "200") {
        message.success(response?.data?.message || response?.message || 'Payment reversed successfully');
        handleReverseModalClose(); // Close the modal
        // if (submitForm) {
        //   await submitForm(initialValues); 
        //   setReverseModalLoading(false);
        // }
        if (getReailerDistIdAgainst ) {
          await getReailerDistIdAgainst(page ? page : 0);
        }

      } else {
        message.error(response?.data?.message || response?.message || 'Failed to reverse payment');
      }
    } catch (err) {
      message.error(err.data?.message || err?.message || 'Failed to reverse payment');
    } finally {
      setReverseModalLoading(false); // Hide loader
    }
  };
  
  const handleCashbackModalOpen = async (record) => {
    setSelectedCashbackUser(record);
    setCashbackEnabled(Boolean(record.is_cashback_wallet_enabled));
    setCashbackChargeType(record.cashback_load_charge_type || 'Percent');
    setCashbackChargeValue(record.cashback_load_charge_value !== undefined ? record.cashback_load_charge_value : 0);
    setCashbackMinAmount(record.cashback_min_amount !== undefined ? record.cashback_min_amount : 100);
    setCashbackMaxAmount(record.cashback_max_amount !== undefined ? record.cashback_max_amount : 50000);
    setCashbackMinFlat(record.cashback_charge_min_flat !== undefined ? record.cashback_charge_min_flat : 10);
    setCashbackMaxPercent(record.cashback_charge_percent !== undefined ? record.cashback_charge_percent : (record.cashback_load_charge_value || 2));
    setCashbackGstRate(record.cashback_gst_rate !== undefined ? record.cashback_gst_rate : 18);
    setCashbackGstType(record.cashback_gst_type || "Include");
    setCashbackUpiMinPerTxn(record.cashback_upi_min_per_txn !== undefined && record.cashback_upi_min_per_txn !== null ? record.cashback_upi_min_per_txn : 500);
    setCashbackUpiMaxPerTxn(record.cashback_upi_max_per_txn !== undefined && record.cashback_upi_max_per_txn !== null ? record.cashback_upi_max_per_txn : 25000);
    setCashbackUpiDailyLimit(record.cashback_upi_daily_limit !== undefined && record.cashback_upi_daily_limit !== null ? record.cashback_upi_daily_limit : 100000);
    setCashbackBankMinPerTxn(record.cashback_bank_min_per_txn !== undefined && record.cashback_bank_min_per_txn !== null ? record.cashback_bank_min_per_txn : 500);
    setCashbackBankMaxPerTxn(record.cashback_bank_max_per_txn !== undefined && record.cashback_bank_max_per_txn !== null ? record.cashback_bank_max_per_txn : 50000);
    setCashbackBankDailyLimit(record.cashback_bank_daily_limit !== undefined && record.cashback_bank_daily_limit !== null ? record.cashback_bank_daily_limit : 200000);
    setCashbackModalVisible(true);

    try {
      if (record?._id) {
        const liveRes = await getUserId(record._id);
        const liveData = liveRes?.data?.data || liveRes?.data;
        if (liveData && (liveData.main_wallet != null || liveData.cashback_wallet != null || liveData.aeps_wallet != null)) {
          setSelectedCashbackUser(prev => ({ ...prev, ...liveData }));
          if (liveData.is_cashback_wallet_enabled !== undefined) {
            setCashbackEnabled(Boolean(liveData.is_cashback_wallet_enabled));
          }
          if (liveData.cashback_load_charge_type) {
            setCashbackChargeType(liveData.cashback_load_charge_type);
          }
          if (liveData.cashback_load_charge_value !== undefined) {
            setCashbackChargeValue(liveData.cashback_load_charge_value);
          }
          if (liveData.cashback_min_amount !== undefined) {
            setCashbackMinAmount(liveData.cashback_min_amount);
          }
          if (liveData.cashback_max_amount !== undefined) {
            setCashbackMaxAmount(liveData.cashback_max_amount);
          }
          if (liveData.cashback_charge_min_flat !== undefined) {
            setCashbackMinFlat(liveData.cashback_charge_min_flat);
          }
          if (liveData.cashback_charge_percent !== undefined) {
            setCashbackMaxPercent(liveData.cashback_charge_percent);
          }
          if (liveData.cashback_gst_rate !== undefined) {
            setCashbackGstRate(liveData.cashback_gst_rate);
          }
          if (liveData.cashback_gst_type) {
            setCashbackGstType(liveData.cashback_gst_type);
          }
          if (liveData.cashback_upi_min_per_txn !== undefined) {
            setCashbackUpiMinPerTxn(liveData.cashback_upi_min_per_txn);
          }
          if (liveData.cashback_upi_max_per_txn !== undefined) {
            setCashbackUpiMaxPerTxn(liveData.cashback_upi_max_per_txn);
          }
          if (liveData.cashback_upi_daily_limit !== undefined) {
            setCashbackUpiDailyLimit(liveData.cashback_upi_daily_limit);
          }
          if (liveData.cashback_bank_min_per_txn !== undefined) {
            setCashbackBankMinPerTxn(liveData.cashback_bank_min_per_txn);
          }
          if (liveData.cashback_bank_max_per_txn !== undefined) {
            setCashbackBankMaxPerTxn(liveData.cashback_bank_max_per_txn);
          }
          if (liveData.cashback_bank_daily_limit !== undefined) {
            setCashbackBankDailyLimit(liveData.cashback_bank_daily_limit);
          }
        }
      }
    } catch (err) {
      console.warn('Could not live fetch user details in modal:', err);
    }
  };

  const handleCashbackModalClose = () => {
    setCashbackModalVisible(false);
    setSelectedCashbackUser(null);
  };

  const handleSaveCashbackSettings = async () => {
    if (!selectedCashbackUser?._id) return;
    try {
      setCashbackModalLoading(true);
      const payload = {
        is_cashback_wallet_enabled: cashbackEnabled,
        cashback_charge_min_flat: Number(cashbackMinFlat) || 0,
        cashback_charge_percent: Number(cashbackMaxPercent) || 0,
        cashback_gst_rate: Number(cashbackGstRate) || 0,
        cashback_gst_type: cashbackGstType,
        cashback_load_charge_type: "Percent",
        cashback_load_charge_value: Number(cashbackMaxPercent) || 0,
        cashback_min_amount: Number(cashbackMinAmount) || 100,
        cashback_max_amount: Number(cashbackMaxAmount) || 50000,
        cashback_upi_min_per_txn: cashbackUpiMinPerTxn !== "" && !isNaN(cashbackUpiMinPerTxn) ? Number(cashbackUpiMinPerTxn) : 500,
        cashback_upi_max_per_txn: cashbackUpiMaxPerTxn !== "" && !isNaN(cashbackUpiMaxPerTxn) ? Number(cashbackUpiMaxPerTxn) : 25000,
        cashback_upi_daily_limit: cashbackUpiDailyLimit !== "" && !isNaN(cashbackUpiDailyLimit) ? Number(cashbackUpiDailyLimit) : 100000,
        cashback_bank_min_per_txn: cashbackBankMinPerTxn !== "" && !isNaN(cashbackBankMinPerTxn) ? Number(cashbackBankMinPerTxn) : 500,
        cashback_bank_max_per_txn: cashbackBankMaxPerTxn !== "" && !isNaN(cashbackBankMaxPerTxn) ? Number(cashbackBankMaxPerTxn) : 50000,
        cashback_bank_daily_limit: cashbackBankDailyLimit !== "" && !isNaN(cashbackBankDailyLimit) ? Number(cashbackBankDailyLimit) : 200000,
      };
      const res = await updateUser(selectedCashbackUser._id, payload);
      // axiosInstance unwraps response.data directly via responseMiddleWare
      const isSuccess = Boolean(
        res?.user ||
        res?._id ||
        res?.statusCode == 200 ||
        res?.status === 200 ||
        res?.data ||
        res?.is_cashback_wallet_enabled !== undefined
      );

      if (isSuccess) {
        message.success('Cashback Wallet settings updated successfully!');
        if (typeof getReailerDistIdAgainst === 'function') {
          getReailerDistIdAgainst(page);
        }
        handleCashbackModalClose();
      } else {
        message.error(res?.message || 'Failed to update settings');
      }
    } catch (err) {
      message.error(err?.response?.data?.message || err?.message || 'Failed to update settings');
    } finally {
      setCashbackModalLoading(false);
    }
  };

  const handleApprovalChange = (value, id) => {
    try {
      handleChange({ target: { value, name: 'is_approved' }}, id);
    } catch (err) {
      message.error('Failed to update approval status');
      setError('Failed to update approval status. Please try again.');
    }
  };

  const actionMenu = (record) => (
    <Menu>
      {/* <Menu.Item key="1">
        <Link to={`/admin/certificate`}>BC Authorization Letter</Link>
      </Menu.Item> */}
      <Menu.Item key="2">
        <Link to="#">ID Card</Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to="#">Certificate</Link>
      </Menu.Item>
      <Menu.Item key="4" onClick={() => handleShow()}>
        Fund Transfer / Return
      </Menu.Item>
      <Menu.Item key="5" onClick={() => handleShow2()}>
        Scheme
      </Menu.Item>
      <Menu.Item key="6" onClick={() => handleShow3()}>
        Add Id Stock
      </Menu.Item>
      <Menu.Item key="7" onClick={() => handleShow4()}>
        Permission
      </Menu.Item>
      <Menu.Item key="8" onClick={() => { handleShow5(record) }}>

        Locked Amount
      </Menu.Item>
      <Menu.Item key="9">
        <Link to="/admin/member/profile/view/3">View Profile</Link>
      </Menu.Item>
      <Menu.Item key="10" onClick={() => handleCashbackModalOpen(record)} style={{ backgroundColor: "#faf5ff", borderTop: "1px solid #f3e8ff" }}>
        <span style={{ color: "#7c3aed", fontWeight: 700 }}>⚡ Cashback Wallet Setting</span>
      </Menu.Item>
    </Menu>
  );

  const reportMenu = (record) => (
    <Menu>
      <Menu.Item key="1">
        <Link to={`/admin/statement/apes/report/${record._id}`}>AEPS</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to={`/admin/statement/billpayment/report/${record._id}`}>Billpayment</Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to={`/admin/statement/recharge/report/${record._id}`}>Recharge</Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to={`/admin/statement/moneyTransfer/report/${record._id}`}>Money Transfer</Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link to="/admin/report/pancard/3">UtiPancard</Link>
      </Menu.Item>
      <Menu.Item key="6">
        <Link to="/admin/statement/report/2">Account Statement</Link>
      </Menu.Item>
      {/* <Menu.Item key="7">
        <Link to="/admin/statementwallet/report/2">Aeps Statement</Link>
      </Menu.Item> */}
      <Menu.Item key="9">
        <Link to={`/admin/aepswallets/report/${record._id}`}>AEPS Wallets Reports</Link>
      </Menu.Item>
      <Menu.Item key="8">
        <Link to={`/admin/wallets/report/${record._id}`}>Main Wallets Reports</Link>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: 'Serial No.',
      key: 'serial',
      width: 90,
      render: (text, record, index) => {
        // Calculate the serial number based on currentPage and the index in the current page
        // const serialNo = index + 1 + currentPage * pageSize; // Assuming pageSize is the number of rows per page
        const serialNo = index + 1;
        return <span style={{ whiteSpace: 'nowrap' }}>{serialNo}</span>;
      },
    },
    {
      title: 'Name & Type',
      key: 'name',
      width: 190,
      render: (text, record) => (
        <div style={{ minWidth: '170px' }}>
          <div className="fw-bold" style={{ whiteSpace: 'nowrap' }}>{record.name || '-'}</div>
          <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>{record.member_type || '-'}</small>
        </div>
      ),
    },
    {
      title: 'Reference Code',
      dataIndex: 'refer_id',
      key: 'refer_id',
      width: 140,
      render: (text) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>,
    },
    {
      title: 'Contact Info',
      key: 'contact',
      width: 190,
      render: (text, record) => (
        <div style={{ minWidth: '160px' }}>
          <div style={{ whiteSpace: 'nowrap' }}>{record.mobile || '-'}</div>
          <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>{record.email || '-'}</small>
        </div>
      ),
    },
    {
      title: 'Main Balance',
      dataIndex: 'main_wallet',
      key: 'main_wallet',
      width: 120,
      render: (text) => <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>₹{text || '0'}</span>,
    },
    {
      title: 'Joining Date/Time',
      key: 'createdAt',
      width: 130,
      render: (text, record) => (
        <div style={{ minWidth: '100px' }}>
          <div style={{ whiteSpace: 'nowrap' }}>{record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '-'}</div>
          <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
            {record.createdAt ? moment(record.createdAt).format('HH:mm:ss') : '-'}
          </small>
        </div>
      ),
    },
    {
      title: params?.name?.toLowerCase() === 'reseller' ? 'Downline User' : 'View Parent',
      key: 'viewparent',
      width: 130,
      render: (text, record) =>
        record?.member_type?.toLowerCase() === 'reseller' ? (
          <Link to={`/admin/reseller-member-list/${record._id}`}>
            <Button size="small" onClick={() => showParentView(record?.uplineChain, record?.downlineSponsors, record)}>
              Downline User
            </Button>
          </Link>
        ) : (
          <Button size="small" onClick={() => showParentView(record?.uplineChain, record?.downlineSponsors, record)}>
            View Parent
          </Button>
        ),
    },
    {
      title: 'User Current Status',
      key: 'status',
      width: 130,
      render: (_, record) => (
        <button
          style={{ minWidth: '90px', padding: '4px 10px', fontSize: '12px' }}
          onClick={() => updateActiveStatus(record)}
          className={record?.status ? `btn btn-success btn-sm` : `btn btn-danger btn-sm`}
        >
          {record?.status ? 'Active' : 'Deactive'}
        </button>
      ),
    },    
    {
      title: 'Status',
      key: 'is_approved',
      width: 130,
      render: (text, record) => (
        <select
          className={`form-select form-select-sm ${record.is_approved ? 'border-success' : 'border-danger'}`}
          style={{ width: '120px' }}
          value={record.is_approved?.toString() || "false"}
          onChange={(e) => handleApprovalChange(e.target.value, record._id)}
        >
          <option value="true">Approved</option>
          <option value="false">Not Approved</option>
        </select>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 180,
      render: (text, record) => (
        <Space size="small" className="d-flex" style={{ whiteSpace: 'nowrap' }}>
          <Dropdown overlay={actionMenu(record)} trigger={['click']}>
            <Button size="small" className="btn-action">
              Action <EllipsisOutlined />
            </Button>
          </Dropdown>
          <Dropdown overlay={reportMenu(record)} trigger={['click']}>
            <Button size="small" className="btn-report">
              Reports <EllipsisOutlined />
            </Button>
          </Dropdown>
          <Link 
            to={`/admin/create-user/${record._id}`} 
            className="btn btn-primary btn-sm"
          >
            <EditOutlined />
          </Link>
        </Space>
      ),
    },
    {
      title: 'Reverse Payment',
      key: 'reversePayment',
      width: 120,
      render: (text, record) => (
        <Button 
          type="primary" 
          danger 
          size="small"
          icon={<RollbackOutlined />}
          onClick={() => handleReverseModalOpen(record)}
          style={{ whiteSpace: 'nowrap' }}
        >
          Reverse
        </Button>
      ),
    },
    ...(params?.name === 'Retailer' ? [{
      title: 'AEPS Reverse Payment',
      key: 'apesreversePayment',
      width: 140,
      render: (text, record) => (
        <Button 
          type="primary" 
          danger 
          size="small"
          icon={<RollbackOutlined />}
          onClick={() => handleaepsReverseModalOpen(record)}
          style={{ whiteSpace: 'nowrap' }}
        >
          AEPS Reverse
        </Button>
      ),
    },
    {
      title: 'Cashback Reverse Payment',
      key: 'cashbackreversePayment',
      width: 150,
      render: (text, record) => (
        <Button 
          type="primary" 
          size="small"
          icon={<RollbackOutlined />}
          style={{ backgroundColor: '#7c3aed', borderColor: '#7c3aed', whiteSpace: 'nowrap' }}
          onClick={() => handleCashbackReverseModalOpen(record)}
        >
          Cashback Reverse
        </Button>
      ),
    }] : [])
  ];
  



  const csvData = excelData?.user?.map(item => {
    // Assuming that `uplineChain` has all the roles (Distributor, Super Distributor, ASM, ZSM, etc.)
    const distributor = item.uplineChain.find(upline => upline.user_type === 'Distributor') || null;
    const superDistributor = item.uplineChain.find(upline => upline.user_type === 'Super Distributor') || null;
    const asm = item.uplineChain.find(upline => upline.user_type === 'asm') || null;
    const zsm = item.uplineChain.find(upline => upline.user_type === 'zsm') || null;
    
    // Create a map for all roles dynamically (expand as necessary)
    const roleMap = {
      'Distributor': distributor,
      'Super Distributor': superDistributor,
      'ASM': asm,
      'ZSM': zsm
    };
  
    // Return the user map with dynamic role fields
    return {
      Name: item.name || '',
      'Member Type': item.member_type || '',
      'Reference Code': item.refer_id || '',
      Mobile: item.mobile || '',
      Email: item.email || '',
      Balance: item.main_wallet || '0',
      'Joining Date': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '',
      Status: item.is_approved ? 'Approved' : 'Not Approved',
      ...Object.keys(roleMap).reduce((acc, role) => {
        const roleData = roleMap[role];
        acc[`${role} Name`] = roleData ? roleData.name : 'N/A';
        acc[`${role} Refer ID`] = roleData ? roleData.refer_id : 'N/A';
        acc[`${role} Mobile`] = roleData ? roleData.mobile : 'N/A';
        acc[`${role} Main Wallet`] = roleData ? roleData.main_wallet : 'N/A';
        return acc;
      }, {}),
    };
  }) || [];

  return (
    <div className="member-list-wrapper" style={{ margin: "2px 16px 16px 16px" }}>
      <Card style={{ marginBottom: "0" }}>
        <Card.Header className=" active-projects style-1" style={{ padding: "4px 16px", minHeight: "unset", borderBottom: "1px solid #f0f0f0" }}>
          
          <div className="w-100 tbl-caption" style={{ padding: "0", margin: "0", minHeight: "unset" }}>
                  <h4 className="heading mb-0" style={{ fontSize: "13px", margin: 0, padding: 0 }}><b>{params?.name || 'Distributor'} List</b></h4>
                  <div>
                   
                    <CSVLink 
                data={csvData} 
                filename={`${params?.name || 'distributor'}_list.csv`}
                className="btn btn-primary border border-white"
                style={{ backgroundColor: 'bs(--nav)', padding: "4px 12px", height: "28px", fontSize: "11.5px", display: "inline-flex", alignItems: "center", gap: "5px" }}
              >
                <DownloadOutlined /> Download Excel
              </CSVLink>
                    
                  </div>
                </div>
        </Card.Header>
        <Card.Body className="p-0">
          {error && (
            <div className="alert alert-danger m-3">
              {error}
            </div>
          )}
          <Table
            columns={columns}
            dataSource={state?.user || []}
            rowKey={(record) => record?._id || Math.random()}
            loading={loading}
            pagination={false}
            className="custom-table"
            scroll={{ x: true }}
          />
          <div className="p-3 d-flex justify-content-between align-items-center">
            <div>
              Total {state?.totalCount || 0} entries
            </div>
            <Pagination
              total={state?.totalCount || 0}
              onChange={onChangeVal}
              showSizeChanger={false}
              current={page+1}
              showQuickJumper
              
            />
          </div>
        </Card.Body>
      </Card>

      {/* Modals */}
      <FundTransfer show={show} handleClose={handleClose} />
            <SchemeManager show2={show2} handleClose2={handleClose2} />
            <IdStocks show3={show3} handleClose3={handleClose3} />
            <MemberPermission show4={show4} handleClose4={handleClose4} />
            <LockAmount show5={show5} handleClose5={handleClose5} getItem={getItem} getReailerDistIdAgainst={getReailerDistIdAgainst} />


            {/* New Reverse Payment Modal */}
            <Modal
    title="Reverse Payment"
    open={showReverseModal}
    onCancel={handleReverseModalClose}
    // confirmLoading={reverseModalLoading}
    footer={[
      <Button key="cancel" onClick={handleReverseModalClose} disabled={reverseModalLoading}>
        Cancel
      </Button>,
      <Button 
        key="submit" 
        type="primary" 
        onClick={handleReversePaymentSubmit}
        loading={reverseModalLoading}
        disabled={
          !reversePaymentData.amount || 
          !reversePaymentData.remark.trim() || 
          !reversePaymentData.tpin.trim()
        }
        // disabled={
        //   !reversePaymentData.amount || // Check if amount is empty or zero
        //   !reversePaymentData.remark || // Check if remark is empty
        //   !reversePaymentData.tpin // Check if TPIN is empty
        // }
      >
        Submit
      </Button>,
    ]}
  >

    <p className='px-2'>Wallet Balance : {userMainWallet}</p>
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Input
        type="number"
        placeholder="Enter Amount"
        value={reversePaymentData.amount}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, amount: Number(e.target.value) }))}
        disabled={reverseModalLoading}
      />
      <Input
        placeholder="Enter Remark"
        value={reversePaymentData.remark}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, remark: e.target.value }))}
        disabled={reverseModalLoading}
      />
      <Input.Password
        placeholder="Enter TPIN"
        value={reversePaymentData.tpin}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, tpin: e.target.value }))}
        disabled={reverseModalLoading}
        autoComplete="new-password"
      />
    </Space>
  </Modal>


  {/* /// */}
  <Modal
    title="AEPS Reverse Payment"
    open={showaepsReverseModal}
    onCancel={handleaepsReverseModalClose}
    // confirmLoading={reverseModalLoading}
    footer={[
      <Button key="cancel" onClick={handleaepsReverseModalClose} disabled={aepsreverseModalLoading}>
        Cancel
      </Button>,
      <Button 
        key="submit" 
        type="primary" 
        onClick={handleaepsReversePaymentSubmit}
        loading={aepsreverseModalLoading}
        disabled={
          !aepsreversePaymentData.amount || 
          !aepsreversePaymentData.remark.trim() || 
          !aepsreversePaymentData.tpin.trim()
        }
        // disabled={
        //   !reversePaymentData.amount || // Check if amount is empty or zero
        //   !reversePaymentData.remark || // Check if remark is empty
        //   !reversePaymentData.tpin // Check if TPIN is empty
        // }
      >
        Submit
      </Button>,
    ]}
  >
      <p className='px-2' style={{ fontWeight: 600, color: "#0369a1" }}>AEPS Wallet Balance : ₹{Number(userAepsWallet || 0).toFixed(2)}</p>
    <Space direction="vertical" style={{ width: '100%' }} size="large">
    
      <Input
        type="number"
        placeholder="Enter Amount"
        value={aepsreversePaymentData.amount}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, amount: Number(e.target.value) }))}
        disabled={reverseModalLoading}
      />
      <Input
        placeholder="Enter Remark"
        value={aepsreversePaymentData.remark}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, remark: e.target.value }))}
        disabled={aepsreverseModalLoading}
      />
      <Input.Password
        placeholder="Enter TPIN"
        value={aepsreversePaymentData.tpin}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, tpin: e.target.value }))}
        disabled={aepsreverseModalLoading}
        autoComplete="new-password"
      />
    </Space>
  </Modal>

  {/* Cashback Reverse Modal */}
  <Modal
    title={
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#7c3aed", fontWeight: 700 }}>
        <span>⚡ Cashback Reverse Payment</span>
      </div>
    }
    open={showCashbackReverseModal}
    visible={showCashbackReverseModal}
    onCancel={handleCashbackReverseModalClose}
    footer={[
      <Button key="cancel" onClick={handleCashbackReverseModalClose} disabled={cashbackReverseModalLoading}>
        Cancel
      </Button>,
      <Button 
        key="submit" 
        type="primary" 
        onClick={handleCashbackReversePaymentSubmit}
        loading={cashbackReverseModalLoading}
        style={{ backgroundColor: "#7c3aed", borderColor: "#7c3aed" }}
        disabled={
          !cashbackReversePaymentData.amount || 
          !cashbackReversePaymentData.remark.trim() || 
          !cashbackReversePaymentData.tpin.trim()
        }
      >
        Submit
      </Button>,
    ]}
  >
    <p className='px-2' style={{ fontWeight: 600, color: "#6b21a8" }}>
      Cashback Wallet Balance : ₹{Number(userCashbackReverseWallet || 0).toFixed(2)}
    </p>
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Input
        type="number"
        placeholder="Enter Amount"
        value={cashbackReversePaymentData.amount}
        onChange={(e) => setCashbackReversePaymentData(prev => ({ ...prev, amount: Number(e.target.value) }))}
        disabled={cashbackReverseModalLoading}
      />
      <Input
        placeholder="Enter Remark"
        value={cashbackReversePaymentData.remark}
        onChange={(e) => setCashbackReversePaymentData(prev => ({ ...prev, remark: e.target.value }))}
        disabled={cashbackReverseModalLoading}
      />
      <Input.Password
        placeholder="Enter TPIN"
        value={cashbackReversePaymentData.tpin}
        onChange={(e) => setCashbackReversePaymentData(prev => ({ ...prev, tpin: e.target.value }))}
        disabled={cashbackReverseModalLoading}
        autoComplete="new-password"
      />
    </Space>
  </Modal>

   {
          isParentViewVisible && <>
           <Modal
          title="Parent & Downline Details"
          open={isParentViewVisible}
          visible={isParentViewVisible}
          onOk={()=> setIsParentViewVisible(false)}
          onCancel={()=> setIsParentViewVisible(false)}
          centered
          width={850}
          footer={[
            <Button key="close" onClick={()=> setIsParentViewVisible(false)}>
              Close
            </Button>
          ]}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 className="mb-0 text-primary" style={{ fontWeight: 600 }}>
                Parent / Upline Details
              </h5>
              {selectedMemberForParent && (
                <small className="text-muted">
                  Member: <strong>{selectedMemberForParent.name || '-'}</strong> ({selectedMemberForParent.member_type || 'User'} - {selectedMemberForParent.refer_id || ''})
                </small>
              )}
            </div>
            <Button
              type={showChangeParentPanel ? "default" : "primary"}
              style={!showChangeParentPanel ? { backgroundColor: '#10b981', borderColor: '#10b981' } : {}}
              onClick={handleToggleChangeParent}
            >
              {showChangeParentPanel ? "Cancel Change" : "🔄 Change Parent / Sponsor"}
            </Button>
          </div>

          {showChangeParentPanel && (
            <div
              className="p-3 mb-3"
              style={{
                backgroundColor: '#f8fafc',
                border: '1px solid #cbd5e1',
                borderRadius: '8px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
              }}
            >
              <div style={{ fontWeight: 600, color: '#1e293b', marginBottom: 12 }}>
                Change Sponsor for {selectedMemberForParent?.name} ({selectedMemberForParent?.refer_id}):
              </div>

              <div className="row g-2 align-items-end">
                <div className="col-md-3">
                  <label style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4 }}>
                    New Parent Role
                  </label>
                  <Select
                    style={{ width: '100%' }}
                    value={changeParentRole}
                    onChange={handleChangeParentRole}
                  >
                    <Select.Option value="ASM">Area Sales Manager (ASM)</Select.Option>
                    <Select.Option value="TSM">Territory Sales Manager (TSM)</Select.Option>
                    <Select.Option value="ZSM">Zonal Sales Manager (ZSM)</Select.Option>
                    <Select.Option value="Super Distributor">Super Distributor</Select.Option>
                    <Select.Option value="Distributor">Distributor</Select.Option>
                    <Select.Option value="Company">Company / Direct Admin</Select.Option>
                  </Select>
                </div>

                <div className="col-md-6">
                  <label style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4 }}>
                    Select New {
                      changeParentRole === 'Company'
                        ? 'Staff (Company)'
                        : changeParentRole === 'ASM'
                        ? 'Area Sales Manager (ASM)'
                        : changeParentRole === 'TSM'
                        ? 'Territory Sales Manager (TSM)'
                        : changeParentRole === 'ZSM'
                        ? 'Zonal Sales Manager (ZSM)'
                        : changeParentRole
                    }
                  </label>
                  <Select
                    style={{ width: '100%' }}
                    showSearch
                    placeholder={
                      changeParentRole === 'Company'
                        ? 'Search Staff by name, email or code'
                        : `Search ${changeParentRole} by name, mobile or code`
                    }
                    value={selectedNewParentId}
                    onChange={(val) => setSelectedNewParentId(val)}
                    loading={eligibleParentsLoading}
                    filterOption={(input, option) =>
                      String(option?.searchtext || option?.children || '').toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {eligibleParentsList.map((p) => (
                      <Select.Option
                        key={p._id}
                        value={p._id}
                        searchtext={`${p.name || ''} ${p.refer_id || ''} ${p.mobile || ''} ${p.user_type || ''}`}
                      >
                        {p.name} {p.refer_id ? `(${p.refer_id})` : ''} {p.mobile ? `[${p.mobile}]` : ''} - {p.user_type}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div className="col-md-3">
                  <Button
                    type="primary"
                    onClick={handleSubmitChangeParent}
                    loading={changeParentSubmitting}
                    disabled={!selectedNewParentId || changeParentSubmitting}
                    style={{ width: '100%', backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                  >
                    Update Parent
                  </Button>
                </div>
              </div>
            </div>
          )}

          <Table
            columns={columnsParent}
            dataSource={parentRecord}
            rowKey={(r, i) => r._id || r.refer_id || i}
            pagination={false}
          />

          {downlineRecord && downlineRecord.length > 0 && (
            <>
              <h5 className="mt-4 mb-2 text-primary" style={{ fontWeight: 600 }}>
                Downline Retailer Details
              </h5>
              <Table
                columns={columnsParent}
                dataSource={downlineRecord}
                rowKey={(r, i) => r._id || r.refer_id || i}
                pagination={false}
              />
            </>
          )}
        </Modal>
          
          </>
        }
      {/* Cashback Wallet Setting Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#7c3aed", fontWeight: 700, fontSize: 17 }}>
            <span>⚡ Cashback Wallet Configuration</span>
          </div>
        }
        open={cashbackModalVisible}
        visible={cashbackModalVisible}
        onCancel={handleCashbackModalClose}
        centered
        width={520}
        footer={[
          <Button key="cancel" onClick={handleCashbackModalClose} disabled={cashbackModalLoading}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={cashbackModalLoading}
            onClick={handleSaveCashbackSettings}
            style={{ backgroundColor: "#7c3aed", borderColor: "#7c3aed" }}
          >
            Save Changes
          </Button>,
        ]}
      >
        {selectedCashbackUser && (
          <div style={{ padding: "8px 0" }}>
            <div style={{ background: "#f8fafc", padding: "12px 16px", borderRadius: 8, marginBottom: 20, border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
                {selectedCashbackUser.name || "Retailer"}
              </div>
              <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
                ID / Refer Code: <span style={{ fontWeight: 600, color: "#334155" }}>{selectedCashbackUser.refer_id || selectedCashbackUser._id}</span>
                {selectedCashbackUser.mobile && <span style={{ marginLeft: 12 }}>📞 {selectedCashbackUser.mobile}</span>}
              </div>
              <div style={{ display: "flex", gap: 12, marginTop: 10, flexWrap: "wrap" }}>
                <div style={{ background: "#faf5ff", border: "1px solid #e9d5ff", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#6b21a8", fontWeight: 600 }}>Cashback Balance: </span>
                  <span style={{ fontWeight: 800, color: "#7c3aed" }}>₹{Number(selectedCashbackUser.cashback_wallet || 0).toFixed(2)}</span>
                </div>
                <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#166534", fontWeight: 600 }}>Main Wallet: </span>
                  <span style={{ fontWeight: 800, color: "#15803d" }}>₹{Number(selectedCashbackUser.main_wallet || 0).toFixed(2)}</span>
                </div>
                <div style={{ background: "#ecfeff", border: "1px solid #a5f3fc", padding: "4px 10px", borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: "#155e75", fontWeight: 600 }}>AEPS Wallet: </span>
                  <span style={{ fontWeight: 800, color: "#0e7490" }}>₹{Number(selectedCashbackUser.aeps_wallet || 0).toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#0f172a" }}>Enable Cashback Wallet Service</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>Allow this retailer to view and use the Cashback Settlement suite</div>
              </div>
              <Switch
                checked={cashbackEnabled}
                onChange={(checked) => setCashbackEnabled(checked)}
                style={{ backgroundColor: cashbackEnabled ? "#7c3aed" : undefined }}
              />
            </div>

            {cashbackEnabled && (
              <div style={{ marginTop: 20, padding: 16, background: "#faf5ff", borderRadius: 8, border: "1px solid #e9d5ff" }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#581c87", marginBottom: 14 }}>
                  Load Deduction & GST Configuration
                </div>

                {/* Row 1: Min(Flat) and max(%) */}
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      Min(Flat)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="0.1"
                      value={cashbackMinFlat}
                      onChange={(e) => setCashbackMinFlat(e.target.value)}
                      placeholder="e.g. 10"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      max(%)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="0.01"
                      value={cashbackMaxPercent}
                      onChange={(e) => setCashbackMaxPercent(e.target.value)}
                      placeholder="e.g. 2 or 0.55"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                </div>

                {/* Row 2: PayOut GST (%) and Include / Exclude */}
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      PayOut GST (%)
                    </label>
                    <Input
                      type="number"
                      min={0}
                      step="1"
                      value={cashbackGstRate}
                      onChange={(e) => setCashbackGstRate(e.target.value)}
                      placeholder="e.g. 18"
                      style={{ width: "100%", borderRadius: 6 }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: "block", fontSize: 13, color: "#475569", marginBottom: 6, fontWeight: 600 }}>
                      Tax Mode
                    </label>
                    <Select
                      value={cashbackGstType}
                      onChange={(val) => setCashbackGstType(val)}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="Include">Include</Select.Option>
                      <Select.Option value="Exclude">Exclude</Select.Option>
                    </Select>
                  </div>
                </div>

                {/* Dynamic Live Calculation Preview */}
                {(() => {
                  const demoAmt = 100;
                  const pctFee = Number(((demoAmt * (Number(cashbackMaxPercent) || 0)) / 100).toFixed(2));
                  const baseFee = Math.max(Number(cashbackMinFlat) || 0, pctFee);
                  const gst = Number(cashbackGstRate) || 0;
                  const gstAmt = cashbackGstType === "Exclude"
                    ? Number(((baseFee * gst) / 100).toFixed(2))
                    : Number((baseFee - (baseFee / (1 + gst / 100))).toFixed(2));
                  const totalFee = cashbackGstType === "Exclude" ? Number((baseFee + gstAmt).toFixed(2)) : Number(baseFee.toFixed(2));
                  const netRec = Math.max(0, Number((demoAmt - totalFee).toFixed(2)));

                  return (
                    <div style={{ background: "#ffffff", border: "1px solid #d8b4fe", padding: "10px 12px", borderRadius: 6, fontSize: 12, color: "#6b21a8" }}>
                      <strong>Live Preview on ₹100 Load:</strong>
                      <div style={{ marginTop: 4 }}>
                        • Calculated %: <strong>₹{pctFee.toFixed(2)}</strong> vs Min(Flat): <strong>₹{(Number(cashbackMinFlat) || 0).toFixed(2)}</strong> ➔ Base: <strong>₹{baseFee.toFixed(2)}</strong>
                      </div>
                      <div style={{ marginTop: 2 }}>
                        • GST ({gst}% {cashbackGstType}): <strong>₹{gstAmt.toFixed(2)}</strong> ➔ Total Deduction: <strong>₹{totalFee.toFixed(2)}</strong>
                      </div>
                      <div style={{ marginTop: 2, color: "#166534", fontWeight: 700 }}>
                        • Retailer receives: ₹{netRec.toFixed(2)} in Cashback Wallet
                      </div>
                    </div>
                  );
                })()}

                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87", marginBottom: 10 }}>
                    Transfer Limits (Main ➔ Cashback)
                  </div>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min Amount (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackMinAmount}
                        onChange={(e) => setCashbackMinAmount(e.target.value)}
                        placeholder="e.g. 100"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max Amount (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackMaxAmount}
                        onChange={(e) => setCashbackMaxAmount(e.target.value)}
                        placeholder="e.g. 50000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#7c3aed", marginTop: 6 }}>
                    Retailer can only add amounts between ₹{cashbackMinAmount || 0} and ₹{cashbackMaxAmount || 0}.
                  </div>
                </div>

                {/* Section: UPI Payout Limits */}
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87" }}>
                      UPI Payout Limits (Cashback ➔ B2B UPI)
                    </div>
                    <span style={{ fontSize: 11, background: "#fef3c7", color: "#b45309", padding: "2px 8px", borderRadius: 4, fontWeight: 600 }}>
                      Instant UPI Rails
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiMinPerTxn}
                        onChange={(e) => setCashbackUpiMinPerTxn(e.target.value)}
                        placeholder="500"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiMaxPerTxn}
                        onChange={(e) => setCashbackUpiMaxPerTxn(e.target.value)}
                        placeholder="25000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 140px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 600, color: "#047857" }}>
                        Daily Total Limit (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackUpiDailyLimit}
                        onChange={(e) => setCashbackUpiDailyLimit(e.target.value)}
                        placeholder="100000"
                        style={{ width: "100%", borderColor: "#a7f3d0" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#059669", marginTop: 6 }}>
                    Retailer can payout ₹{cashbackUpiMinPerTxn || 0} to ₹{cashbackUpiMaxPerTxn || 0} per UPI transaction (Max ₹{cashbackUpiDailyLimit || 0}/day).
                  </div>
                </div>

                {/* Section: Bank Transfer Payout Limits */}
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #d8b4fe" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#581c87" }}>
                      Bank Transfer Payout Limits (Cashback ➔ B2B Bank)
                    </div>
                    <span style={{ fontSize: 11, background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 4, fontWeight: 600 }}>
                      IMPS / NEFT
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Min / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankMinPerTxn}
                        onChange={(e) => setCashbackBankMinPerTxn(e.target.value)}
                        placeholder="500"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 120px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 500 }}>
                        Max / Txn (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankMaxPerTxn}
                        onChange={(e) => setCashbackBankMaxPerTxn(e.target.value)}
                        placeholder="50000"
                        style={{ width: "100%" }}
                        prefix="₹"
                      />
                    </div>
                    <div style={{ flex: "1 1 140px" }}>
                      <label style={{ display: "block", fontSize: 11.5, color: "#475569", marginBottom: 4, fontWeight: 600, color: "#1d4ed8" }}>
                        Daily Total Limit (₹):
                      </label>
                      <Input
                        type="number"
                        min={1}
                        value={cashbackBankDailyLimit}
                        onChange={(e) => setCashbackBankDailyLimit(e.target.value)}
                        placeholder="200000"
                        style={{ width: "100%", borderColor: "#bfdbfe" }}
                        prefix="₹"
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#2563eb", marginTop: 6 }}>
                    Retailer can payout ₹{cashbackBankMinPerTxn || 0} to ₹{cashbackBankMaxPerTxn || 0} per Bank transaction (Max ₹{cashbackBankDailyLimit || 0}/day).
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default DistributorList;